import { render, staticRenderFns } from "./el-option.vue?vue&type=template&id=4e72d8a4"
import script from "./el-option.vue?vue&type=script&lang=js"
export * from "./el-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports